import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { fmDataContext } from "../../Context/FmData";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import LoadingCircle from "../LoadingCircle/LoadingCircle";
import { fmLabelsContext } from "../../Context/LabelsContext";
import userCan from "../../helpers/userCan";
import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Swal from "sweetalert2/dist/sweetalert2.all.min";
import "@sweetalert2/theme-dark/dark.min.css";
import jwtDecode from "jwt-decode";
import ReleaseCard from "../ReleaseCard/ReleaseCard";
import VideoCard from "../VideoCard/VideoCard";
import ArtistCard from "../ArtistCard/ArtistCard";
import styles from "./LabelDetails.module.scss";
import { authenticationContext } from "../../Context/AuthContext";

const LabelDetails = () => {
  let [mounted, setMounted] = useState(false);

  let { labelId } = useParams();
  let [params, setParams] = useSearchParams();

  let { baseUrl, navigate, showData, editItemExistence, getData, globalCrumbs, setGlobalCrumbs } = useContext(fmDataContext);
  let { user } = useContext(authenticationContext);

  let [currentLabel, setCurrentLabel] = useState({});
  let onlyTrashed = params.get("archived");
  let [isCurrentLabelLoading, setIsCurrentLabelLoading] = useState(true);

  let [isSoftDeleteLoading, setIsSoftDeleteLoading] = useState(false);
  let [isForceDeleteLoading, setIsForceDeleteLoading] = useState(false);
  let [isRestoreLoading, setIsRestoreLoading] = useState(false);

  let { setLabelMsg } = useContext(fmLabelsContext);

  let userToken = jwtDecode(localStorage.getItem("userToken")).accessToken;

  let artistsSearchInput = useRef();
  let releasesSearchInput = useRef();
  let videosSearchInput = useRef();

  let [artistsSwiperCount, setArtistsSwiperCount] = useState(6);
  let [releasesSwiperCount, setReleasesSwiperCount] = useState(4);
  let [videosSwiperCount, setVideosSwiperCount] = useState(2);

  const softDeleteLabel = (reqMethod, pathName, headers, setLoading) => {
    if (userCan("fm_label_soft_delete")) {
      Swal.fire({
        title: "Are you sure?",
        html: `<p class="mb-0">You will delete <span class="fu-text-light-gray">${currentLabel.data.label_name}</span></p>`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          cancelButton: "popup-btn",
          confirmButton: "popup-btn",
        },
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          editItemExistence(reqMethod, pathName, headers, setLoading)
            .then((response) => {
              setLabelMsg(`${currentLabel.data.label_name} Deleted Successfully`);
              navigate("/fm-labels");
            })
            .catch((error) => {
              navigate("/not-found");
            });
        }
      });
    } else {
      navigate("/not-found");
    }
  };

  const restoreLabel = (reqMethod, pathName, headers, setLoading) => {
    if (userCan("fm_label_restore_trashed")) {
      Swal.fire({
        title: "Are you sure?",
        html: `<p class="mb-0">You will restore <span class="fu-text-light-gray">${currentLabel.data.label_name}</span></p>`,
        icon: "question",
        showCancelButton: true,
        customClass: {
          cancelButton: "popup-btn",
          confirmButton: "popup-btn",
        },
        confirmButtonText: "Yes, restore it!",
      }).then((result) => {
        if (result.isConfirmed) {
          editItemExistence(reqMethod, pathName, headers, setLoading)
            .then((response) => {
              setLabelMsg(`${currentLabel.data.label_name} Restored Successfully`);
              navigate("/fm-labels");
            })
            .catch((error) => {
              navigate("/not-found");
            });
        }
      });
    } else {
      navigate("/not-found");
    }
  };

  const forceDeleteLabel = (reqMethod, pathName, headers, setLoading) => {
    Swal.fire({
      title: "Are you sure?",
      html: `<p class="mb-0">You will delete <span class="fu-text-light-gray">${currentLabel.data.label_name}</span> permanently</p><p class="mb-0">You won't be able to revert this!</p>`,
      icon: "warning",
      showCancelButton: true,
      customClass: {
        cancelButton: "popup-btn",
        confirmButton: "popup-btn",
      },
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (userCan("fm_label_force_delete")) {
          editItemExistence(reqMethod, pathName, headers, setLoading)
            .then((response) => {
              setLabelMsg(`${currentLabel.data.label_name} Deleted Permanently Successfully`);
              navigate("/fm-labels");
            })
            .catch((error) => {
              navigate("/not-found");
            });
        } else {
          navigate("/not-found");
        }
      }
    });
  };

  const setArtistsSlidesCount = () => {
    if (window.innerWidth > 1400) {
      setArtistsSwiperCount(6);
    } else if (window.innerWidth < 1400 && window.innerWidth >= 1200) {
      setArtistsSwiperCount(5);
    } else if (window.innerWidth < 1200 && window.innerWidth > 991.9) {
      setArtistsSwiperCount(4);
    } else if (window.innerWidth < 992 && window.innerWidth > 767.9) {
      setArtistsSwiperCount(3);
    } else if (window.innerWidth < 768 && window.innerWidth > 575.9) {
      setArtistsSwiperCount(2);
    } else if (window.innerWidth < 576 && window.innerWidth > 0) {
      setArtistsSwiperCount(1);
    }
  };

  const setReleasesSlidesCount = () => {
    if (window.innerWidth >= 1400) {
      setReleasesSwiperCount(4);
    } else if (window.innerWidth < 1400 && window.innerWidth > 1199.9) {
      setReleasesSwiperCount(3);
    } else if (window.innerWidth < 1200 && window.innerWidth > 991.9) {
      setReleasesSwiperCount(3);
    } else if (window.innerWidth < 992 && window.innerWidth > 767.9) {
      setReleasesSwiperCount(2);
    } else if (window.innerWidth < 768 && window.innerWidth > 0) {
      setReleasesSwiperCount(1);
    }
  };

  const setVideosSlidesCount = () => {
    if (window.innerWidth > 1200) {
      setVideosSwiperCount(2);
    } else if (window.innerWidth < 1200 && window.innerWidth > 991.9) {
      setVideosSwiperCount(2);
    } else if (window.innerWidth < 992 && window.innerWidth > 767.9) {
      setVideosSwiperCount(1);
    } else if (window.innerWidth < 768 && window.innerWidth > 0) {
      setVideosSwiperCount(1);
    }
  };

  const getLabel = (reqMethod, pathName, setLoading = setIsCurrentLabelLoading, headers, params) => {
    showData(reqMethod, pathName, setLoading, headers, params)
      .then((response) => {
        // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
        // if (response.data.data.label_image.includes("via.placeholder.com")) {
        //   response.data.data.label_image = response.data.data.label_image.replace("http://127.0.0.1:8000/storage/", "");
        // }
        // if (response.data.data.label_releases !== null) {
        //   response.data.data.label_releases.forEach((release) => {
        //     if (release.release_image.includes("via.placeholder.com")) {
        //       release.release_image = release.release_image.replace("http://127.0.0.1:8000/storage/", "");
        //     }
        //   });
        // }
        // if (response.data.data.label_artists !== null) {
        //   response.data.data.label_artists.forEach((artist) => {
        //     if (artist.artist_image.includes("via.placeholder.com")) {
        //       artist.artist_image = artist.artist_image.replace("http://127.0.0.1:8000/storage/", "");
        //     }
        //   });
        // }
        // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
        setCurrentLabel(response.data);
        setLoading(false);
      })
      .catch((error) => {
        navigate("/not-found");
      });
  };

  useEffect(() => {
    getLabel(
      "GET",
      `${baseUrl}fm-label/${labelId}`,
      setIsCurrentLabelLoading,
      {
        Accept: "application/json",
        "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
        Authorization: `Bearer ${userToken}`,
      },
      {
        only_trashed: onlyTrashed,
      }
    );
    setMounted(true);

    setArtistsSlidesCount();
    setReleasesSlidesCount();
    setVideosSlidesCount();
    window.addEventListener("resize", function () {
      setArtistsSlidesCount();
      setReleasesSlidesCount();
      setVideosSlidesCount();
    });
  }, []);

  useEffect(() => {
    getLabel(
      "GET",
      `${baseUrl}fm-label/${labelId}`,
      setIsCurrentLabelLoading,
      {
        Accept: "application/json",
        "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
        Authorization: `Bearer ${userToken}`,
      },
      {
        only_trashed: onlyTrashed,
      }
    );
    setMounted(true);
  }, [labelId]);

  useEffect(() => {
    if (mounted && currentLabel.data) {
      let globalCrumbsUpdated = globalCrumbs.map((crumb) => {
        if (crumb.name === labelId.toUpperCase()) {
          crumb.name = currentLabel.data.label_name.toUpperCase();
        }
        return crumb;
      });
      setGlobalCrumbs(globalCrumbsUpdated);
    }
  }, [currentLabel]);

  let [releasesSearchTimeOut, setReleasesSearchTimeOut] = useState("");
  let [releasesSearchText, setReleasesSearchText] = useState("");
  let [isReleasesSearchLoading, setIsReleasesSearchLoading] = useState(false);

  const getSearchReleases = () => {
    setIsReleasesSearchLoading(true);
    if (releasesSearchTimeOut) {
      clearTimeout(releasesSearchTimeOut);
    }
    let getReleasesSearchTimeOut = setTimeout(() => {
      getData(
        "GET",
        `${baseUrl}fm-releases`,
        {
          search_query: releasesSearchText,
          label_keys: [currentLabel.data.label_key],
        },
        setIsReleasesSearchLoading
      )
        .then((response) => {
          // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
          // if (response.data.data.label_releases !== null) {
          //   response.data.data.forEach((release) => {
          //     if (release.release_image.includes("via.placeholder.com")) {
          //       release.release_image = release.release_image.replace("http://127.0.0.1:8000/storage/", "");
          //     }
          //   });
          // }
          // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
          setIsReleasesSearchLoading(false);
          currentLabel.data.label_releases = response.data.data;
        })
        .catch((error) => {
          navigate("/not-found");
        });
    }, 1500);
    setReleasesSearchTimeOut(getReleasesSearchTimeOut);
  };

  useEffect(() => {
    if (mounted) {
      getSearchReleases();
    }
  }, [releasesSearchText]);

  let [videosSearchTimeOut, setVideosSearchTimeOut] = useState("");
  let [videosSearchText, setVideosSearchText] = useState("");
  let [isVideosSearchLoading, setIsVideosSearchLoading] = useState(false);

  const getSearchVideos = () => {
    setIsVideosSearchLoading(true);
    if (videosSearchTimeOut) {
      clearTimeout(videosSearchTimeOut);
    }
    let getVideosSearchTimeOut = setTimeout(() => {
      getData(
        "GET",
        `${baseUrl}fm-videos`,
        {
          search_query: videosSearchText,
          label_keys: [currentLabel.data.label_key],
        },
        setIsVideosSearchLoading
      )
        .then((response) => {
          setIsVideosSearchLoading(false);
          currentLabel.data.label_videos = response.data.data;
        })
        .catch((error) => {
          navigate("/not-found");
        });
    }, 1500);
    setVideosSearchTimeOut(getVideosSearchTimeOut);
  };

  useEffect(() => {
    if (mounted) {
      getSearchVideos();
    }
  }, [videosSearchText]);

  let [artistsSearchTimeOut, setArtistsSearchTimeOut] = useState("");
  let [artistsSearchText, setArtistsSearchText] = useState("");
  let [isArtistsSearchLoading, setIsArtistsSearchLoading] = useState(false);

  const getSearchArtists = () => {
    setIsArtistsSearchLoading(true);

    if (artistsSearchTimeOut) {
      clearTimeout(artistsSearchText);
    }
    let getArtistsSearchTimeOut = setTimeout(() => {
      getData(
        "GET",
        `${baseUrl}fm-artists`,
        {
          search_query: artistsSearchText,
          label_keys: [currentLabel.data.label_key],
        },
        setIsArtistsSearchLoading
      )
        .then((response) => {
          // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
          // if (response.data.data.label_artists !== null) {
          //   response.data.data.forEach((artist) => {
          //     if (artist.artist_image.includes("via.placeholder.com")) {
          //       artist.artist_image = artist.artist_image.replace("http://127.0.0.1:8000/storage/", "");
          //     }
          //   });
          // }
          // ------------------ REMOVE BEFORE PRODUCTION --------------------------------
          setIsArtistsSearchLoading(false);
          currentLabel.data.label_artists = response.data.data;
        })
        .catch((error) => {
          navigate("/not-found");
        });
    }, 1500);
    setArtistsSearchTimeOut(getArtistsSearchTimeOut);
  };

  useEffect(() => {
    if (mounted) {
      getSearchArtists();
    }
  }, [artistsSearchText]);

  return (
    <>
      {!isCurrentLabelLoading ? (
        <>
          <div className={styles.cover_container}>
            {currentLabel.data.label_image ? <div className={styles.label_cover_bg_blur} style={{ backgroundImage: `url(${currentLabel.data.label_image})` }}></div> : ""}
            <div className={styles.label_box}>
              <div className="mb-3">
                {currentLabel.data.label_image ? (
                  <div className={styles.label_pic}>
                    <img src={currentLabel.data.label_image} alt="label" className="w-100 h-100" />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="mb-2 mb-sm-3 mb-md-4">
                <div className={styles.label_name_container}>
                  <h2 className={`mb-0 ${styles.label_name}`}>{currentLabel.data.label_name ? currentLabel.data.label_name : ""}</h2>
                </div>
              </div>
              <div className={styles.social_box}>
                <div className={styles.social_media_links}>
                  {/* FACEBOOK */}
                  {currentLabel.data.label_social_media_links.facebook_url ? (
                    <div>
                      <a href={currentLabel.data.label_social_media_links.facebook_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* INSTA */}
                  {currentLabel.data.label_social_media_links.instagram_url ? (
                    <div>
                      <a href={currentLabel.data.label_social_media_links.instagram_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={16} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.46494 1.066C8.63828 1.01222 9.01228 1 12 1C14.9883 1 15.3617 1.01283 16.5344 1.066C17.7059 1.11917 18.5059 1.30556 19.2056 1.5775C19.9395 1.85381 20.6043 2.28674 21.1538 2.84617C21.7133 3.3956 22.1463 4.06046 22.4225 4.79439C22.6944 5.49411 22.8802 6.29406 22.934 7.46494C22.9878 8.63828 23 9.01228 23 12C23 14.9877 22.9872 15.3617 22.934 16.5351C22.8808 17.7059 22.6944 18.5059 22.4225 19.2056C22.1414 19.9286 21.7649 20.5427 21.1538 21.1538C20.6044 21.7133 19.9395 22.1463 19.2056 22.4225C18.5059 22.6944 17.7059 22.8802 16.5351 22.934C15.3617 22.9878 14.9877 23 12 23C9.01228 23 8.63828 22.9872 7.46494 22.934C6.29406 22.8808 5.49411 22.6944 4.79439 22.4225C4.07144 22.1414 3.45728 21.7649 2.84617 21.1538C2.28664 20.6044 1.85368 19.9395 1.5775 19.2056C1.30556 18.5059 1.11978 17.7059 1.066 16.5351C1.01222 15.3617 1 14.9883 1 12C1 9.01167 1.01283 8.63828 1.066 7.46556C1.11917 6.29406 1.30556 5.49411 1.5775 4.79439C1.85381 4.06051 2.28674 3.39568 2.84617 2.84617C3.39559 2.28664 4.06045 1.85368 4.79439 1.5775C5.49411 1.30556 6.29406 1.11978 7.46494 1.066ZM16.4452 3.046C15.2853 2.99344 14.937 2.98183 12 2.98183C9.063 2.98183 8.71467 2.99344 7.55478 3.046C6.48228 3.09489 5.89989 3.27394 5.51244 3.42489C4.99911 3.62411 4.63244 3.86244 4.24744 4.24744C3.86306 4.63244 3.62411 4.99911 3.42489 5.51244C3.27394 5.89989 3.09489 6.48228 3.046 7.55478C2.99344 8.71467 2.98183 9.063 2.98183 12C2.98183 14.937 2.99344 15.2853 3.046 16.4452C3.09489 17.5177 3.27394 18.1001 3.42489 18.4876C3.60111 18.9654 3.88219 19.3976 4.24744 19.7526C4.60234 20.1178 5.03461 20.3989 5.51244 20.5751C5.89989 20.7261 6.48228 20.9051 7.55478 20.954C8.71467 21.0066 9.06239 21.0182 12 21.0182C14.9376 21.0182 15.2853 21.0066 16.4452 20.954C17.5177 20.9051 18.1001 20.7261 18.4876 20.5751C19.0009 20.3759 19.3676 20.1376 19.7526 19.7526C20.1178 19.3977 20.3989 18.9654 20.5751 18.4876C20.7261 18.1001 20.9051 17.5177 20.954 16.4452C21.0066 15.2853 21.0182 14.937 21.0182 12C21.0182 9.063 21.0066 8.71467 20.954 7.55478C20.9051 6.48228 20.7261 5.89989 20.5751 5.51244C20.3759 4.99911 20.1376 4.63244 19.7526 4.24744C19.3676 3.86306 19.0009 3.62411 18.4876 3.42489C18.1001 3.27394 17.5177 3.09489 16.4452 3.046ZM10.5955 15.3909C11.0408 15.5754 11.518 15.6703 12 15.6703C12.9735 15.6703 13.907 15.2836 14.5953 14.5953C15.2837 13.907 15.6704 12.9734 15.6704 12C15.6704 11.0266 15.2837 10.093 14.5953 9.40468C13.907 8.71636 12.9735 8.32966 12 8.32966C11.518 8.32966 11.0408 8.4246 10.5955 8.60905C10.1501 8.7935 9.74553 9.06385 9.40471 9.40468C9.06389 9.7455 8.79353 10.1501 8.60908 10.5954C8.42463 11.0407 8.3297 11.518 8.3297 12C8.3297 12.482 8.42463 12.9593 8.60908 13.4046C8.79353 13.8499 9.06389 14.2545 9.40471 14.5953C9.74553 14.9361 10.1501 15.2065 10.5955 15.3909ZM8.00205 8.00201C9.06238 6.94168 10.5005 6.34599 12 6.34599C13.4996 6.34599 14.9377 6.94168 15.998 8.00201C17.0583 9.06234 17.654 10.5005 17.654 12C17.654 13.4995 17.0583 14.9376 15.998 15.998C14.9377 17.0583 13.4996 17.654 12 17.654C10.5005 17.654 9.06238 17.0583 8.00205 15.998C6.94172 14.9376 6.34603 13.4995 6.34603 12C6.34603 10.5005 6.94172 9.06234 8.00205 8.00201ZM18.9077 7.18838C19.1583 6.93773 19.2991 6.59779 19.2991 6.24333C19.2991 5.88886 19.1583 5.54892 18.9077 5.29828C18.657 5.04764 18.3171 4.90683 17.9626 4.90683C17.6082 4.90683 17.2682 5.04764 17.0176 5.29828C16.7669 5.54892 16.6261 5.88886 16.6261 6.24333C16.6261 6.59779 16.7669 6.93773 17.0176 7.18838C17.2682 7.43902 17.6082 7.57983 17.9626 7.57983C18.3171 7.57983 18.657 7.43902 18.9077 7.18838Z"></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* X */}
                  {currentLabel.data.label_social_media_links.x_url ? (
                    <div>
                      <a href={currentLabel.data.label_social_media_links.x_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={17} viewBox="0 0 512 512" id="twitter">
                          <g clipPath="url(#clip0_84_15698)">
                            <path className={styles.social_icon} width={17} d="M355.904 100H408.832L293.2 232.16L429.232 412H322.72L239.296 302.928L143.84 412H90.8805L214.56 270.64L84.0645 100H193.28L268.688 199.696L355.904 100ZM337.328 380.32H366.656L177.344 130.016H145.872L337.328 380.32Z"></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* THRADS */}
                  {currentLabel.data.label_social_media_links.threads_url ? (
                    <div>
                      <a href={currentLabel.data.label_social_media_links.threads_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={15} aria-label="Threads" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg">
                          <path
                            className="x19hqcy"
                            d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"></path>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* LINKEDIN */}
                  {currentLabel.data.label_social_media_links.linkedin_url ? (
                    <div>
                      <a href={currentLabel.data.label_social_media_links.linkedin_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={15} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path
                              strokeWidth="evenodd"
                              d="M20.3292112,2 C21.2519624,2 22,2.74752185 22,3.67078882 L22,20.3292112 C22,21.2519624 21.2524781,22 20.3292112,22 L3.67078882,22 C2.74803764,22 2,21.2524781 2,20.3292112 L2,3.67078882 C2,2.74803764 2.74752185,2 3.67078882,2 L20.3292112,2 Z M15.51875,9.5 C14.0993287,9.5 13.128125,10.127356 12.6956992,10.8562567 L12.625,10.9858333 L12.625,9.625 L9.91666667,9.625 L9.91666667,19.2083333 L12.8333333,19.2083333 L12.8333333,14.56625 C12.8333333,13.0104167 13.40625,12.0208333 14.7833333,12.0208333 C15.7330797,12.0208333 16.1315784,12.8606664 16.1644352,14.3580086 L16.1666667,14.56625 L16.1666667,19.2083333 L19.0833333,19.2083333 L19.0833333,13.9154167 C19.0833333,11.0575 18.3995833,9.5 15.51875,9.5 Z M7.83333333,9.5 L4.91666667,9.5 L4.91666667,19.0833333 L7.83333333,19.0833333 L7.83333333,9.5 Z M6.375,4.5 C5.33958333,4.5 4.5,5.33958333 4.5,6.375 C4.5,7.41041667 5.33958333,8.25 6.375,8.25 C7.41041667,8.25 8.25,7.41041667 8.25,6.375 C8.25,5.33958333 7.41041667,4.5 6.375,4.5 Z"></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* TIKTOK */}
                  {currentLabel.data.label_social_media_links.tiktok_url ? (
                    <div>
                      <a href={currentLabel.data.label_social_media_links.tiktok_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={15} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* DISCORD */}
                  {currentLabel.data.label_social_media_links.discord_url ? (
                    <div>
                      <a href={currentLabel.data.label_social_media_links.discord_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={15} viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* WEBSITE */}
                  {currentLabel.data.label_social_media_links.website_url ? (
                    <div>
                      <a href={currentLabel.data.label_social_media_links.website_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={16} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path d="m24 12c0-.002 0-.004 0-.006 0-3.551-1.546-6.74-4.001-8.933l-.012-.01c-.031-.033-.064-.062-.101-.087l-.002-.001c-2.095-1.84-4.859-2.962-7.886-2.962-3.032 0-5.8 1.126-7.91 2.984l.013-.011c-.026.02-.049.041-.07.065v.001c-2.478 2.205-4.031 5.403-4.031 8.963 0 3.55 1.544 6.739 3.997 8.933l.012.01c0 .003.002.005.005.005.031.035.065.065.101.092l.002.001c2.094 1.837 4.857 2.958 7.881 2.958 3.032 0 5.801-1.126 7.911-2.984l-.013.011c.03-.022.056-.045.08-.07 2.475-2.202 4.026-5.395 4.026-8.951 0-.002 0-.005 0-.007zm-4.462 7.805c-.576-.468-1.223-.897-1.909-1.262l-.065-.032c.613-1.767.982-3.804 1.017-5.923v-.016h4.261c-.156 2.852-1.391 5.388-3.301 7.23zm-6.966-1.505c1.283.069 2.482.351 3.588.81l-.072-.026c-.886 2.02-2.133 3.408-3.516 3.713zm0-1.144v-4.584h4.868c-.043 1.961-.383 3.828-.976 5.578l.039-.131c-1.157-.484-2.498-.795-3.903-.862l-.027-.001zm0-5.728v-4.584c1.431-.069 2.772-.379 4.007-.891l-.079.029c.555 1.619.896 3.485.94 5.425v.021zm0-5.728v-4.495c1.383.305 2.63 1.687 3.516 3.713-1.034.43-2.233.711-3.487.781zm2.854-4c1.238.419 2.312 1.009 3.258 1.752l-.023-.018c-.443.348-.94.676-1.464.961l-.056.028c-.449-1.047-1.025-1.947-1.724-2.737l.009.011zm-4-.492v4.492c-1.283-.069-2.482-.35-3.588-.81l.072.026c.89-2.02 2.135-3.407 3.518-3.712zm-4.568 3.212c-.58-.315-1.077-.642-1.544-1.007l.024.018c.923-.726 1.996-1.315 3.158-1.712l.076-.023c-.689.778-1.265 1.678-1.689 2.658l-.025.065zm4.57 2.423v4.584h-4.868c.044-1.961.385-3.827.979-5.577l-.039.131c1.156.483 2.497.794 3.901.861zm0 5.728v4.584c-1.431.069-2.772.379-4.007.891l.079-.029c-.555-1.618-.896-3.485-.94-5.425v-.021zm0 5.728v4.495c-1.383-.305-2.63-1.687-3.516-3.713 1.034-.43 2.233-.71 3.487-.78l.029-.001zm-2.85 4c-1.238-.418-2.311-1.006-3.258-1.748l.024.018c.443-.348.94-.676 1.464-.961l.056-.028c.445 1.047 1.022 1.947 1.723 2.733l-.009-.01zm8.564-2.72c.58.315 1.077.642 1.544 1.007l-.024-.018c-.923.726-1.996 1.315-3.158 1.712l-.076.023c.689-.778 1.265-1.677 1.689-2.657l.025-.065zm5.7-8.151h-4.261c-.035-2.135-.404-4.172-1.058-6.078l.041.138c.751-.399 1.397-.828 1.997-1.312l-.024.018c1.913 1.845 3.148 4.381 3.303 7.205l.001.028zm-18.38-7.233c.576.468 1.223.897 1.909 1.262l.065.032c-.613 1.767-.982 3.804-1.017 5.923v.016h-4.262c.156-2.852 1.391-5.388 3.301-7.23l.003-.003zm-3.304 8.377h4.261c.035 2.135.404 4.172 1.058 6.078l-.041-.138c-.751.399-1.397.828-1.997 1.312l.024-.018c-1.913-1.845-3.148-4.381-3.303-7.205l-.001-.028z"></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className={styles.streaming_links}>
                  {/* BEATPORT */}
                  {currentLabel.data.label_streaming_platforms_links.beatport_url ? (
                    <div>
                      <a href={currentLabel.data.label_streaming_platforms_links.beatport_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={16} viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path d="M14.668 24c-3.857 0-6.935-3.039-6.935-6.974a6.98 6.98 0 0 1 1.812-4.714l-4.714 4.714-2.474-2.474 5.319-5.26c.72-.72 1.09-1.656 1.09-2.688V0h3.487v6.604c0 2.026-.72 3.74-2.123 5.143l-.156.156a6.945 6.945 0 0 1 4.694-1.812c3.955 0 6.975 3.136 6.975 6.935A6.943 6.943 0 0 1 14.668 24zm0-10.714c-2.123 0-3.779 1.753-3.779 3.74 0 2.045 1.675 3.78 3.78 3.78a3.804 3.804 0 0 0 3.818-3.78c0-2.065-1.715-3.74-3.819-3.74z"></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* SPOTIFY */}
                  {currentLabel.data.label_streaming_platforms_links.spotify_url ? (
                    <div>
                      <a href={currentLabel.data.label_streaming_platforms_links.spotify_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={18} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path d="M24.849 14.35c-3.206-1.616-6.988-2.563-10.991-2.563-2.278 0-4.484 0.306-6.58 0.881l0.174-0.041c-0.123 0.040-0.265 0.063-0.412 0.063-0.76 0-1.377-0.616-1.377-1.377 0-0.613 0.401-1.132 0.954-1.311l0.010-0.003c5.323-1.575 14.096-1.275 19.646 2.026 0.426 0.258 0.706 0.719 0.706 1.245 0 0.259-0.068 0.502-0.186 0.712l0.004-0.007c-0.29 0.345-0.721 0.563-1.204 0.563-0.273 0-0.529-0.070-0.752-0.192l0.008 0.004zM24.699 18.549c-0.201 0.332-0.561 0.55-0.971 0.55-0.225 0-0.434-0.065-0.61-0.178l0.005 0.003c-2.739-1.567-6.021-2.49-9.518-2.49-1.925 0-3.784 0.28-5.539 0.801l0.137-0.035c-0.101 0.032-0.217 0.051-0.337 0.051-0.629 0-1.139-0.51-1.139-1.139 0-0.509 0.333-0.939 0.793-1.086l0.008-0.002c1.804-0.535 3.878-0.843 6.023-0.843 3.989 0 7.73 1.064 10.953 2.925l-0.106-0.056c0.297 0.191 0.491 0.52 0.491 0.894 0 0.227-0.071 0.437-0.192 0.609l0.002-0.003zM22.899 22.673c-0.157 0.272-0.446 0.452-0.777 0.452-0.186 0-0.359-0.057-0.502-0.154l0.003 0.002c-2.393-1.346-5.254-2.139-8.299-2.139-1.746 0-3.432 0.261-5.020 0.745l0.122-0.032c-0.067 0.017-0.145 0.028-0.224 0.028-0.512 0-0.927-0.415-0.927-0.927 0-0.432 0.296-0.795 0.696-0.898l0.006-0.001c1.581-0.47 3.397-0.74 5.276-0.74 3.402 0 6.596 0.886 9.366 2.44l-0.097-0.050c0.302 0.15 0.506 0.456 0.506 0.809 0 0.172-0.048 0.333-0.132 0.469l0.002-0.004zM16 1.004c0 0 0 0-0 0-8.282 0-14.996 6.714-14.996 14.996s6.714 14.996 14.996 14.996c8.282 0 14.996-6.714 14.996-14.996v0c-0.025-8.272-6.724-14.971-14.993-14.996h-0.002z"></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* YOUTUBE */}
                  {currentLabel.data.label_streaming_platforms_links.youtube_url ? (
                    <div>
                      <a href={currentLabel.data.label_streaming_platforms_links.youtube_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={16} sversion="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 260 180" enableBackground="new 0 0 260 180" space="preserve">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path d="M220,2H40C19.01,2,2,19.01,2,40v100c0,20.99,17.01,38,38,38h180c20.99,0,38-17.01,38-38V40C258,19.01,240.99,2,220,2z M102,130V50l68,40L102,130z"></path>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* SOUNDCLOUD */}
                  {currentLabel.data.label_streaming_platforms_links.sound_cloud_url ? (
                    <div>
                      <a href={currentLabel.data.label_streaming_platforms_links.sound_cloud_url} target="_blank" rel="noreferrer" className={styles.social_icon_container}>
                        <svg className={styles.social_icon} width={16} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 97.774 97.774" space="preserve">
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <g>
                              <g>
                                <g>
                                  <path d="M4.723,49.69c-0.209,0-0.38,0.166-0.407,0.395l-0.961,8.781l0.961,8.586c0.027,0.229,0.198,0.396,0.407,0.396 c0.206,0,0.373-0.164,0.406-0.395l1.094-8.588l-1.094-8.781C5.096,49.851,4.929,49.69,4.723,49.69z"></path> <path d="M1.108,53.054c-0.203,0-0.365,0.156-0.392,0.383L0,58.866l0.716,5.337c0.026,0.226,0.188,0.382,0.392,0.382 c0.198,0,0.359-0.156,0.391-0.38l0.847-5.339l-0.847-5.434C1.467,53.21,1.306,53.054,1.108,53.054z"></path>
                                  <path d="M8.564,47.968c-0.258,0-0.464,0.202-0.49,0.48L7.161,58.866l0.913,10.037c0.026,0.279,0.232,0.48,0.49,0.48 c0.253,0,0.459-0.201,0.489-0.479l1.036-10.039L9.053,48.447C9.023,48.17,8.817,47.968,8.564,47.968z"></path> <path d="M12.437,47.6c-0.304,0-0.551,0.242-0.575,0.564L11,58.869l0.862,10.354c0.024,0.32,0.271,0.563,0.575,0.563 c0.299,0,0.545-0.243,0.573-0.563l0.979-10.354L13.01,48.162C12.982,47.842,12.736,47.6,12.437,47.6z"></path>
                                  <polygon points="16.996,69.31 16.996,69.31 16.996,69.312 "></polygon> <path d="M16.996,48.935c-0.024-0.365-0.308-0.644-0.656-0.644c-0.353,0-0.635,0.278-0.657,0.647l-0.814,9.93l0.814,10.441 c0.022,0.367,0.305,0.646,0.657,0.646c0.349,0,0.632-0.279,0.656-0.646l0.923-10.441L16.996,48.935z"></path>
                                  <path d="M20.276,41.985c-0.396,0-0.72,0.322-0.74,0.733l-0.764,16.155l0.764,10.44c0.021,0.406,0.345,0.729,0.74,0.729 c0.392,0,0.716-0.322,0.74-0.732v0.004l0.864-10.44l-0.864-16.156C20.991,42.307,20.667,41.985,20.276,41.985z"></path>
                                  <path d="M24.181,38.264c-0.443,0-0.804,0.358-0.824,0.815c0,0.002-0.715,19.85-0.715,19.85l0.716,10.375 c0.02,0.455,0.38,0.813,0.823,0.813c0.44,0,0.804-0.358,0.823-0.815v0.006l0.809-10.379l-0.809-19.85 C24.985,38.622,24.621,38.264,24.181,38.264z"></path>
                                  <path d="M28.241,36.47c-0.491,0-0.89,0.396-0.907,0.9c0,0.001-0.665,21.508-0.665,21.508l0.665,10.268 c0.018,0.5,0.416,0.895,0.907,0.895c0.488,0,0.887-0.395,0.907-0.898v0.006l0.751-10.27L29.148,37.37 C29.127,36.866,28.729,36.47,28.241,36.47z"></path>
                                  <path d="M33.26,36.647c-0.017-0.552-0.452-0.985-0.989-0.985c-0.541,0-0.976,0.434-0.991,0.985l-0.616,22.231l0.617,10.204 c0.015,0.546,0.449,0.978,0.99,0.978c0.537,0,0.973-0.432,0.989-0.981l0.694-10.198L33.26,36.647z"></path> <polygon points="33.26,69.078 33.26,69.078 33.26,69.083 "></polygon>
                                  <path d="M36.332,36.149c-0.59,0-1.061,0.469-1.075,1.068l-0.566,21.665l0.568,10.105c0.013,0.593,0.483,1.064,1.073,1.064 c0.586,0,1.057-0.472,1.073-1.07v0.008l0.638-10.109l-0.638-21.666C37.389,36.616,36.918,36.149,36.332,36.149z"></path>
                                  <path d="M40.425,36.856c-0.636,0-1.146,0.507-1.158,1.153L38.75,58.882l0.517,10.045c0.012,0.64,0.522,1.145,1.158,1.145 c0.635,0,1.144-0.505,1.156-1.152v0.008l0.58-10.043l-0.58-20.875C41.569,37.363,41.06,36.856,40.425,36.856z"></path>
                                  <path d="M45.235,33.02c-0.196-0.133-0.433-0.211-0.686-0.211c-0.246,0-0.475,0.075-0.668,0.201 c-0.339,0.221-0.566,0.602-0.572,1.036l-0.004,0.234l-0.466,24.598c0,0.014,0.47,9.984,0.47,9.984 c0,0.016,0.002,0.027,0.003,0.042c0.014,0.278,0.119,0.534,0.288,0.737c0.229,0.273,0.57,0.449,0.949,0.449 c0.337,0,0.644-0.139,0.868-0.363c0.225-0.223,0.367-0.531,0.373-0.873l0.052-0.986l0.471-8.984l-0.522-24.839 C45.783,33.618,45.563,33.242,45.235,33.02z"></path>
                                  <polygon points="45.79,68.862 45.79,68.859 45.79,68.863 45.79,68.858 45.79,68.854 45.79,68.854 45.79,68.859 "></polygon> <path d="M49.329,30.665c-0.196-0.12-0.428-0.19-0.673-0.19c-0.316,0-0.607,0.114-0.836,0.302 c-0.294,0.243-0.484,0.609-0.49,1.019l-0.003,0.136l-0.54,26.956l0.276,4.982l0.267,4.85c0.011,0.717,0.604,1.311,1.326,1.311 c0.719,0,1.312-0.594,1.322-1.32v0.01v0.002l0.59-9.834l0,0L49.98,31.794C49.973,31.315,49.711,30.896,49.329,30.665z"></path>
                                  <path d="M85.748,46.063c-1.646,0-3.22,0.334-4.65,0.933c-0.959-10.837-10.047-19.339-21.133-19.339 c-2.714,0-5.357,0.534-7.693,1.437c-0.907,0.352-1.147,0.712-1.156,1.414c0,0.001,0,38.168,0,38.168 c0.009,0.735,0.579,1.308,1.298,1.379c0.031,0.004,33.336,0,33.336,0c6.642,0,12.025-5.324,12.025-11.967 C97.774,51.447,92.391,46.063,85.748,46.063z"></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="py-2 mt-4">
              <div className="d-flex align-items-center justify-content-center flex-wrap mb-4">
                {currentLabel.data.label_deleted_at === null ? (
                  userCan("fm_label_update") ? (
                    <div className="mx-2 my-1 my-sm-0">
                      <Link to={`/fm-labels/update/${currentLabel.data.label_key}`} className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`} disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                        <span className="btn-bg"></span>
                        Edit
                      </Link>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {currentLabel.data.label_deleted_at === null ? (
                  userCan("fm_label_soft_delete") ? (
                    <div className="mx-2 my-1 my-sm-0">
                      <button
                        className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`}
                        onClick={() =>
                          softDeleteLabel(
                            "DELETE",
                            `${baseUrl}fm-labels/delete/${currentLabel.data.label_key}`,
                            {
                              Accept: "application/json",
                              "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                              Authorization: `Bearer ${user.accessToken}`,
                            },
                            setIsSoftDeleteLoading
                          )
                        }
                        disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                        <span className="btn-bg"></span>
                        Delete
                      </button>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {currentLabel.data.label_deleted_at !== null ? (
                  userCan("fm_label_restore_trashed") ? (
                    <div className="mx-2 my-1 my-sm-0">
                      <button
                        className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`}
                        onClick={() =>
                          restoreLabel(
                            "PATCH",
                            `${baseUrl}fm-labels/restore/${currentLabel.data.label_key}`,
                            {
                              Accept: "application/json",
                              "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                              Authorization: `Bearer ${user.accessToken}`,
                            },
                            setIsRestoreLoading
                          )
                        }
                        disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                        <span className="btn-bg"></span>
                        Restore
                      </button>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {userCan("fm_label_force_delete") ? (
                  <div className="ms-2 my-1 my-sm-0">
                    <button
                      className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`}
                      onClick={() =>
                        forceDeleteLabel(
                          "DELETE",
                          `${baseUrl}fm-labels/force-delete/${currentLabel.data.label_key}`,
                          {
                            Accept: "application/json",
                            "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                            Authorization: `Bearer ${user.accessToken}`,
                          },
                          setIsForceDeleteLoading
                        )
                      }
                      disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                      <span className="btn-bg"></span>
                      Force Delete
                    </button>
                  </div>
                ) : (
                  ""
                )}
                {isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? (
                  <div className="position-relative ms-4">
                    <LoadingCircle circleCont={35} icon={30} loader={35} dot={35} />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="label-tags">
                <div className="mb-4 info-tags-container">
                  {currentLabel.data._id ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">#ID: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data._id}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_key ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">#KEY: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data.label_key}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_artists_count !== null ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">LABEL ARTISTS COUNT: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data.label_artists_count}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_videos_count !== null ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">LABEL VIDEOS COUNT: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data.label_videos_count}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_releases_count !== null ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">LABEL RELEASES COUNT: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data.label_releases_count}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_created_at ? (
                    userCan("created_at_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED AT: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentLabel.data.label_created_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_updated_at ? (
                    userCan("updated_at_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED AT: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentLabel.data.label_updated_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_deleted_at ? (
                    userCan("deleted_at_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">DELETED AT: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentLabel.data.label_deleted_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_created_by ? (
                    userCan("created_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, NAME: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data.label_created_by.name}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_created_by ? (
                    userCan("created_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, #ID: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data.label_created_by._id}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_created_by ? (
                    userCan("created_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, KEY: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data.label_created_by.key}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_updated_by ? (
                    userCan("updated_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, NAME: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data.label_updated_by.name}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_updated_by ? (
                    userCan("updated_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, #ID: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data.label_updated_by._id}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {currentLabel.data.label_updated_by ? (
                    userCan("updated_by_show") ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, KEY: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentLabel.data.label_updated_by.key}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {currentLabel.data.label_bio !== null ? (
                <div className="mb-4">
                  <div className="mb-3 iu-row-heading">
                    <h2 className="mb-0 row-title">ABOUT</h2>
                  </div>
                  <div>
                    <p className={styles.label_bio} dangerouslySetInnerHTML={{ __html: currentLabel.data.label_bio }} />
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* label releases */}
              {currentLabel.data.label_releases !== null ? (
                <div className="mb-4">
                  <div className="d-flex flex-column flex-lg-row align-items-center mb-4">
                    <div className="flex-grow-1 iu-row-heading mb-2 mb-lg-0">
                      <h2 className="mb-0 row-title">RELEASES</h2>
                    </div>
                    <div className="d-flex justify-content-between align-items-center row-search-container ms-0 ms-lg-2">
                      <div className="item-search-box-container flex-grow-1">
                        <div className="loading-fixed-dimensions item-search-box-loading">
                          {isReleasesSearchLoading ? (
                            <div className="position-relative">
                              <LoadingCircle circleCont={20} icon={15} loader={20} dot={20} />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="item-search-box">
                          <input
                            type="text"
                            className="form-control shadow-none"
                            id="releases_search_query"
                            placeholder={`${currentLabel.data.label_name} Releases Search...`}
                            onInput={(e) => {
                              setReleasesSearchText(e.target.value);
                              clearTimeout(releasesSearchTimeOut);
                            }}
                            ref={releasesSearchInput}
                          />
                        </div>
                      </div>
                      <div className="ms-2">
                        <button
                          className="fu-btn fu-btn-gray"
                          onClick={() => {
                            setReleasesSearchText("");
                            clearTimeout(releasesSearchTimeOut);
                            releasesSearchInput.current.value = "";
                          }}>
                          <span className="btn-bg"></span>
                          Clear Search
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="item-releases-search-row-height">
                    {releasesSearchText.length > 0 && !isReleasesSearchLoading && currentLabel.data.label_releases.length === 0 ? (
                      <div className="d-flex flex-column justify-content-center align-items-center item-releases-search-msg-height">
                        <div>
                          <h2 className="fu-text-3-rem fu-text-yellow">
                            <i className="bi bi-search"></i>
                          </h2>
                        </div>
                        <div>
                          <h3 className="h5 fu-text-light-gray line-clamp-2">
                            There Are No Releases Related To<span className="d-inline-flex fu-text-yellow mx-2">{currentLabel.data.label_name}</span>With This Text<span className="d-inline-flex fu-text-yellow mx-2">"{releasesSearchText}"</span>
                          </h3>
                        </div>
                      </div>
                    ) : (
                      <div className="row gx-3">
                        <Swiper className="myswiper px-2 h-100" slidesPerView={releasesSwiperCount} spaceBetween={10} keyboard={true} navigation={true} modules={[Navigation, Keyboard]}>
                          {currentLabel.data.label_releases.map((release, index) => (
                            <SwiperSlide key={index}>
                              <ReleaseCard release={release} />
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* label videos */}
              {currentLabel.data.label_videos !== null ? (
                <div className="mb-4">
                  <div className="d-flex flex-column flex-lg-row align-items-center mb-4">
                    <div className="flex-grow-1 iu-row-heading mb-2 mb-lg-0">
                      <h2 className="mb-0 row-title">VIDEOS</h2>
                    </div>
                    <div className="d-flex justify-content-between align-items-center row-search-container ms-0 ms-lg-2">
                      <div className="item-search-box-container flex-grow-1">
                        <div className="loading-fixed-dimensions item-search-box-loading">
                          {isVideosSearchLoading ? (
                            <div className="position-relative">
                              <LoadingCircle circleCont={20} icon={15} loader={20} dot={20} />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="item-search-box">
                          <input
                            type="text"
                            className="form-control shadow-none"
                            id="video_search_query"
                            placeholder={`${currentLabel.data.label_name} Videos Search...`}
                            onInput={(e) => {
                              setVideosSearchText(e.target.value);
                              clearTimeout(videosSearchTimeOut);
                            }}
                            ref={videosSearchInput}
                          />
                        </div>
                      </div>
                      <div className="ms-2">
                        <button
                          className="fu-btn fu-btn-gray"
                          onClick={() => {
                            setVideosSearchText("");
                            clearTimeout(videosSearchTimeOut);
                            videosSearchInput.current.value = "";
                          }}>
                          <span className="btn-bg"></span>
                          Clear Search
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="item-videos-search-row-height">
                    {videosSearchText.length > 0 && !isVideosSearchLoading && currentLabel.data.label_videos.length === 0 ? (
                      <div className="d-flex flex-column justify-content-center align-items-center item-videos-search-msg-height">
                        <div>
                          <h2 className="fu-text-3-rem fu-text-yellow">
                            <i className="bi bi-search"></i>
                          </h2>
                        </div>
                        <div>
                          <h3 className="h5 fu-text-light-gray line-clamp-2">
                            There Are No Videos Related To<span className="d-inline-flex fu-text-yellow mx-2">{currentLabel.data.label_name}</span>With This Text<span className="d-inline-flex fu-text-yellow mx-2">"{videosSearchText}"</span>
                          </h3>
                        </div>
                      </div>
                    ) : (
                      <div className="row gx-3">
                        <Swiper className="myswiper py-3 px-2 h-100" slidesPerView={videosSwiperCount} spaceBetween={10} keyboard={true} navigation={true} modules={[Navigation, Keyboard]}>
                          {currentLabel.data.label_videos.map((video, index) => (
                            <SwiperSlide key={index}>
                              <VideoCard video={video} />
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* label artists */}
              {currentLabel.data.label_artists !== null ? (
                <div className="mb-4">
                  <div className="d-flex flex-column flex-lg-row align-items-center mb-4">
                    <div className="flex-grow-1 iu-row-heading mb-2 mb-lg-0">
                      <h2 className="mb-0 row-title">ARTISTS</h2>
                    </div>
                    <div className="d-flex justify-content-between align-items-center row-search-container ms-0 ms-lg-2">
                      <div className="item-search-box-container flex-grow-1">
                        <div className="loading-fixed-dimensions item-search-box-loading">
                          {isArtistsSearchLoading ? (
                            <div className="position-relative">
                              <LoadingCircle circleCont={20} icon={15} loader={20} dot={20} />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="item-search-box">
                          <input
                            type="text"
                            className="form-control shadow-none"
                            id="artist_search_query"
                            placeholder={`${currentLabel.data.label_name} Artists Search...`}
                            onInput={(e) => {
                              setArtistsSearchText(e.target.value);
                              clearTimeout(artistsSearchTimeOut);
                            }}
                            ref={artistsSearchInput}
                          />
                        </div>
                      </div>
                      <div className="ms-2">
                        <button
                          className="fu-btn fu-btn-gray"
                          onClick={() => {
                            setArtistsSearchText("");
                            clearTimeout(artistsSearchTimeOut);
                            artistsSearchInput.current.value = "";
                          }}>
                          <span className="btn-bg"></span>
                          Clear Search
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="item-artists-search-row-height">
                    {artistsSearchText.length > 0 && !isArtistsSearchLoading && currentLabel.data.label_artists.length === 0 ? (
                      <div className="d-flex flex-column justify-content-center align-items-center item-artists-search-msg-height">
                        <div>
                          <h2 className="fu-text-3-rem fu-text-yellow">
                            <i className="bi bi-search"></i>
                          </h2>
                        </div>
                        <div>
                          <h3 className="h5 fu-text-light-gray line-clamp-2">
                            There Are No Artists Related To<span className="d-inline-flex fu-text-yellow mx-2">{currentLabel.data.label_name}</span>With This Text<span className="d-inline-flex fu-text-yellow mx-2">"{artistsSearchText}"</span>
                          </h3>
                        </div>
                      </div>
                    ) : (
                      <div className="row gx-3">
                        <Swiper className="myswiper py-3 px-2 h-100" slidesPerView={artistsSwiperCount} spaceBetween={10} keyboard={true} navigation={true} modules={[Navigation, Keyboard]}>
                          {currentLabel.data.label_artists.map((artist, index) => (
                            <SwiperSlide key={index}>
                              <ArtistCard artist={artist} />
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
};

export default LabelDetails;
